export default __webpack_public_path__ + "static/media/img8.405e5314.png";